import React from "react";
import { Button, Card, Divider, Stack, Typography } from "@mui/material";
import "../../assets/styles.css";
import viewIcon from "../../assets/images/icon-view.svg";

interface GeneralCardProps {
  data: any;
  handleClick: (a: any) => void;
  cardContainerClass?: any
  cardContainerStyle?: any
}

const GeneralCard: React.FC<GeneralCardProps> = ({ data, handleClick, cardContainerClass, cardContainerStyle}) => {
  return (
    <Card className={`abc generalCard ${cardContainerClass}`} style={cardContainerStyle}>
      <Stack
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        className="def"
      >
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="8px"
          className="ghi"
        >
          <img src={data.image} alt="icon access" />
          <Typography className={`cardTitle`}>{data?.cardTitle}</Typography>
        </Stack>
      </Stack>
      <Divider className={`cardDivider`}></Divider>
      <Typography
        className={`cardContent lineClampEllipsis`}
      >
        {data?.cardContent}
      </Typography>
      <Button className={`cardButton`} onClick={() => handleClick(data?.name)}>
        View
        <img src={viewIcon} alt="view icon" />
      </Button>
    </Card>
  );
};

export default GeneralCard;
